"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Color_1 = __importDefault(require("./Color"));
const UsageMap = function (props) {
    const { value, label, colors, width } = props;
    return (react_1.default.createElement("div", { className: "glx-usage-comp", style: { width } },
        react_1.default.createElement("div", { className: "glx-usage-comp-map-bar" }, value.map((v) => typeof v === 'number' ? (react_1.default.createElement("div", { style: {
                width: '4px',
                height: `${v}%`,
                backgroundColor: (0, Color_1.default)(v, colors),
            } })) : (react_1.default.createElement("div", { style: {
                width: '4px',
                height: `${v.val}%`,
                backgroundColor: v.color,
            } })))),
        react_1.default.createElement("div", { className: "glx-usage-comp-label" }, label)));
};
UsageMap.defaultProps = {
    colors: undefined,
    width: undefined,
};
exports.default = UsageMap;
